import { combineReducers } from 'redux';
import { AsyncState } from '../../../store/types';
import type { TermsOverviewState } from './types';
import * as types from './types';
import initialState from './initialState';

type Action = { type: string; payload?: any };

const defaultAction = { type: '' };

const financingTermsReducer = (
  state: Record<string, unknown> | null = initialState.entities,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.FETCH_FINANCING_TERMS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
};

const fetchFinancingTermsReducer = (
  state: AsyncState = initialState.financingTerms,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.FETCH_FINANCING_TERMS_BEGIN:
      return {
        ...initialState.financingTerms,
        isLoading: true
      };
    case types.FETCH_FINANCING_TERMS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.FETCH_FINANCING_TERMS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

const fetchTermsOverviewReducer = (
  state: TermsOverviewState = initialState.termsOverview,
  action: Action = defaultAction
) => {
  switch (action.type) {
    case types.FETCH_TERMS_OVERVIEW_BEGIN:
      return {
        ...state,
        isLoading: true
      };
    case types.FETCH_TERMS_OVERVIEW_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.FETCH_TERMS_OVERVIEW_SUCCESS:
      return {
        ...state,
        overview: action.payload,
        isLoading: false
      };
    case types.TOGGLE_COAPPLICANT_STATUS_SUCCESS:
      return {
        ...state,
        overview: {
          ...state?.overview,
          coApplicantToggleOn: action.payload
        }
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  entities: financingTermsReducer,
  financingTerms: fetchFinancingTermsReducer,
  termsOverview: fetchTermsOverviewReducer
});

export default reducer;
